// Generated by ReScript, PLEASE EDIT WITH CARE


function getTdsForm(url) {
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "tdsForm") {
    return ;
  }
  var match$1 = match.tl;
  if (match$1 && !match$1.tl) {
    return {
            TAG: /* TdsForm */2,
            _0: match$1.hd
          };
  }
  
}

var RouteManager = {
  getTdsForm: getTdsForm
};

export {
  RouteManager ,
  
}
/* No side effect */
